var render = function render(){var _vm=this,_c=_vm._self._c;return _c('component',_vm._b({},'component',_vm.componentAttrs,false),[_c('el-button',{attrs:{"type":_vm.type},on:{"click":_vm.handleClick}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }